'use strict';
var novicell = novicell || {};

novicell.navigation = novicell.navigation || function () {

    function init() {
        site_nav();
        sub_menu_toggle();
    }

    function site_nav() {
        var site_nav_input = document.getElementById('input-toggle__site-nav'),
            search_toggle = document.getElementById('input-toggle__site-search'),
            nav_close = document.getElementById('js-dark-overlay');

        site_nav_input.addEventListener('change', function(event) {
            event.stopPropagation();

            if (search_toggle.checked) {
                search_toggle.checked = false;
            }

            var checkbox = event.target,
                site_nav = document.getElementById('js-site-nav'),
                site_nav_item = site_nav.querySelectorAll('.site-nav__inner > ul > li'),
                i = 0;

            if (checkbox.checked) {
                ( document.documentElement )
                    ? document.documentElement.classList.add('no-scroll')
                    : document.body.classList.add('no-scroll');

                bodyScrollLock.clearAllBodyScrollLocks();
                bodyScrollLock.disableBodyScroll(site_nav);

                function site_nav_item_timeout(i) {
                    setTimeout(function() {
                        site_nav_item[i].classList.add('visible');
                    }, i*50);
                }

                function site_nav_timeout(i) {
                    setTimeout(function() {
                        site_nav_item_timeout(i)
                    }, 200);
                }

                for (i = 0; i < site_nav_item.length; i++) { 
                    site_nav_timeout(i);

                    var current = site_nav_item[i];

                    if ( !current.classList.contains('open') && current.classList.contains('current-page-ancestor') ) {
                        var current_open = current,
                            sub_menu = current.querySelector('.sub-menu');
                        
                        setTimeout(function() {
                            sub_menu.style.height = '100%';
                            var height = sub_menu.scrollHeight + 'px';
                            sub_menu.style.height = '';
                            
                            sub_menu.style.height = height;
                            current_open.classList.add('open');
                        }, 900);
                    }
                }

                i = 0;

            } else {
                function site_nav_item_timeout(i) {
                    setTimeout(function() {
                        site_nav_item[i].classList.remove('visible');
                    }, i*50);
                }

                for (i = 0; i < site_nav_item.length; i++) { 
                    site_nav_item_timeout(i);

                    var current = site_nav_item[i];

                    if ( current.classList.contains('open') ) {
                        var current_open = current,
                            sub_menu = current.querySelector('.sub-menu');
                        
                        setTimeout(function() {
                            sub_menu.style.height = '0px';
                            current_open.classList.remove('open');
                        }, 1200);
                    }
                }
                
                i = 0;
                
                ( document.documentElement )
                    ? document.documentElement.classList.remove('no-scroll')
                    : document.body.classList.remove('no-scroll');

                bodyScrollLock.clearAllBodyScrollLocks();
            }
        });
    }

    function sub_menu_toggle() {
        var site_nav = document.getElementById('js-site-nav');

        if ( site_nav ) {
            var site_nav_item = site_nav.getElementsByClassName('menu-item-has-children');

            for (var i = 0; i < site_nav_item.length; i++) {
                var sub_menu_toggle = site_nav_item[i].querySelector('.js-sub-menu-toggle-btn');

                sub_menu_toggle.addEventListener('click', function() {
                    var nav_item = this.parentElement,
                        sub_menu = nav_item.querySelector('.sub-menu');

                    if ( !nav_item.classList.contains('open') ) {
                        sub_menu.style.height = '100%';
                        var height = sub_menu.scrollHeight + 'px';
                        sub_menu.style.height = '';

                        sub_menu.style.height = height;
                        nav_item.classList.add('open');
                    } else {
                        sub_menu.style.height = '0px';
                        nav_item.classList.remove('open');
                    }

                });
            }

        }
    }

    return {
        init : init
    };

}();